module.exports = __webpack_public_path__ + "img/declined.82fccd2b.svg";